import { Segment, Mode, WeekDay } from './../enums';
import { getMonthList } from './month-list';
import { getMonthCode } from './month';
import { getWeekDayList } from './week-day-list';
import { getWeekDayCode } from './week-day';
import { detectMode } from './detect-mode';
import { createValue } from './create-value';
import { parseToValues } from './parse-to-values';
import { isCommonSegment } from './is-segment';
import { dayOfWeekAcceptedMode, commonAcceptedMode, dayOfMonthAcceptedMode, monthAcceptedMode } from './accepted-mode';
export function parseSegment(value, segment) {
    const mode = detectMode(value);
    const rawValues = parseToValues(value, mode);
    const values = normalizeValues(mode, rawValues, segment);
    if (dayOfWeekAcceptedMode(mode) && segment === Segment.dayOfWeek) {
        return createValue(mode, values);
    }
    if (commonAcceptedMode(mode) && isCommonSegment(segment)) {
        return createValue(mode, values);
    }
    if (dayOfMonthAcceptedMode(mode) && segment === Segment.dayOfMonth) {
        return createValue(mode, values);
    }
    if (monthAcceptedMode(mode) && segment === Segment.month) {
        return createValue(mode, values);
    }
    throw `Not available value model for segment: ${segment} and mode: ${mode} of value: ${value}`;
}
const normalizeValues = (mode, values, valueType) => {
    // conver 1,2,3 to SUN,MON,TUE
    if (valueType === Segment.dayOfWeek && [Mode.AND, Mode.RANGE].includes(mode)) {
        return normalizeDayOfWeekValues(values);
    }
    else if (valueType === Segment.month && mode === Mode.AND) {
        return normalizeMonthValues(values);
    }
    return values;
};
const normalizeMonthValues = (values) => {
    return values
        .map(v => {
        const value = +v;
        if (isNaN(value)) {
            return v;
        }
        const month = [
            undefined,
            ...getMonthList()
        ][value];
        if (!month) {
            return v;
        }
        return getMonthCode(month);
    })
        .filter(v => !!v);
};
const normalizeDayOfWeekValues = (values) => {
    return values
        .map(v => {
        const value = +v;
        if (isNaN(value)) {
            return v;
        }
        const weekDay = [
            ...getWeekDayList(),
            WeekDay.Sunday
        ][value];
        return getWeekDayCode(weekDay);
    })
        .filter(v => !!v);
};
